var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.929,
    height: 36.009,
    viewBox: "0 0 48.929 36.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6381 -4115.491)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6398.454 4115.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.814,81.58a7.919,7.919,0,0,1-2.272.337,6.97,6.97,0,0,1-2.209-.349,5.342,5.342,0,0,1-3.54-3.5c-.911-3.043,1.185-6.267,4.772-7.341a7.987,7.987,0,0,1,1.682-.315V61.669a3.277,3.277,0,0,1,.051-.575H10.268v5.9A4.374,4.374,0,0,1,5.9,71.361H0V90.219A2.279,2.279,0,0,0,2.279,92.5H20.089a2.279,2.279,0,0,0,2.279-2.279V77.731a5.973,5.973,0,0,1-.816,1.378,7.5,7.5,0,0,1-3.738,2.472Zm0,0",
    transform: "translate(0 -56.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.178,66.992v-5.9L0,69.271H5.9a2.279,2.279,0,0,0,2.279-2.279Zm0,0",
    transform: "translate(0 -56.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.487.221a1.178,1.178,0,0,0-1.065-.158L172.641,3.715a1.181,1.181,0,0,0-.8,1.116V15.869a4.933,4.933,0,0,0-1.5-.227,5.831,5.831,0,0,0-1.67.249,5.767,5.767,0,0,0-1.848.928,3.819,3.819,0,0,0-1.668,4.185c.658,1.933,3.183,2.821,5.639,1.985a4.66,4.66,0,0,0,3.412-4.031,2.944,2.944,0,0,0-.006-.37V5.675l8.425-2.854v8.991a5.4,5.4,0,0,0-3.44.063c-2.456.836-3.914,3.081-3.255,5.013s3.183,2.821,5.639,1.985a4.651,4.651,0,0,0,3.412-4.056h0V1.178a1.179,1.179,0,0,0-.492-.957Zm0,0",
    transform: "translate(-153.503)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.4,2.133a2,2,0,0,1,3.2,0l8,10.667A2,2,0,0,1,20,16H4a2,2,0,0,1-1.6-3.2Z",
    transform: "translate(6397 4127.5) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.56dd3c655f4197811f4b2248ec4964e7.svg";
export { ForwardRef as ReactComponent };